import Stack, { type StackProps } from '@liquidweb-dev/undercurrent/Stack';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';

const PageLayoutContent = ({ children, sx, ...rest }: StackProps) => (
	<Stack
		sx={combineSx(
			{
				transition: 'ease-in-out 0.2s',
				paddingX: { md: 700 },
				paddingBottom: 700,
			},
			sx,
		)}
		{...rest}
	>
		<Stack maxWidth="1200px" marginX="auto" width="100%" flexGrow={1}>
			{children}
		</Stack>
	</Stack>
);

export default PageLayoutContent;
